import script from "./StudentClinicianTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./StudentClinicianTable.vue?vue&type=script&lang=ts&setup=true"

import "./StudentClinicianTable.vue?vue&type=style&index=0&id=44480248&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44480248"]])

export default __exports__